import { toast } from "react-toastify";
import Order from "../../services/Order";
import { Aviation } from "../../services";

export const createChatActions = (dispatch, t) => ({
  setConnectionStatus: (data) => {
    dispatch({
      type: "SET_CONNECTION_STATUS",
      payload: data,
    });

    // if (data.connected && data.reconnected) {
    //   console.log("Chat connection restored");
    // } else if (data.error && !data.reconnecting) {
    //   console.log("Chat connection error:", data.error);
    // }
  },

  openChatModal: (orderId, chatType = "driver-order", partnerId = null, isAirOrder = false) => {
    dispatch({
      type: "OPEN_CHAT_MODAL",
      payload: { orderId, chatType, partnerId, isAirOrder },
    });
  },

  closeChatModal: () => {
    dispatch({
      type: "CLOSE_CHAT_MODAL",
    });
  },

  registerChat: (orderId, refreshCallback, isModalChat = false) => {
    dispatch({
      type: "REGISTER_CHAT",
      payload: { orderId, refreshCallback, isModalChat },
    });
  },

  unregisterChat: (orderId) => {
    dispatch({
      type: "UNREGISTER_CHAT",
      payload: { orderId },
    });
  },

  setRefreshCallback: (callback) => {
    dispatch({
      type: "SET_REFRESH_CALLBACK",
      payload: { callback },
    });
  },

  addToastShown: (orderId) => {
    dispatch({
      type: "ADD_TOAST_SHOWN",
      payload: { orderId },
    });
  },

  removeToastShown: (orderId) => {
    dispatch({
      type: "REMOVE_TOAST_SHOWN",
      payload: { orderId },
    });
  },

  resetState: () => {
    dispatch({ type: "RESET_STATE" });
  },
});

export const createOrderChatHandler = (state, actions, user, t, lang = "ru") => {
  return async (data) => {
    if (!data) {
      console.warn("handleOrderChat: No data provided");
      return;
    }

    const { companyId, orderId, from } = data;

    if (!companyId || !orderId || from !== "driver") {
      console.warn("handleOrderChat: Invalid message data", { companyId, orderId, from });
      return;
    }

    if (!user?.companyId || user.companyId !== companyId) {
      // console.log("handleOrderChat: Message not for this company", {
      //   userCompanyId: user?.companyId,
      //   messageCompanyId: companyId,
      // });
      return;
    }

    const openChat = state.openChats.get(orderId);
    if (openChat?.refreshCallback) {
      // console.log("handleOrderChat: Chat is already open, refreshing messages", { orderId });
      try {
        await openChat.refreshCallback();
        return;
      } catch (error) {
        console.error("handleOrderChat: Error refreshing open chat", { orderId, error });
      }
    }

    if (state.toastsShown.has(orderId)) {
      // console.log("handleOrderChat: Toast already shown for this order", { orderId });
      return;
    }

    try {
      actions.addToastShown(orderId);

      const orderResponse = await Order.getOrderById(orderId, lang);

      if (!orderResponse?.data) {
        throw new Error("No order data received");
      }

      const orderData = orderResponse.data;
      const cityFromName = orderData.cityFromName || "Не указан";
      const cityToName = orderData.cityToName || "Не указан";
      const orderNumber = orderData.number || "Без номера";

      const toastMessage = `${t("orderChat.newMessageFromDriver")}
${t("orderChat.order")}: №${orderNumber}
${cityFromName} - ${cityToName}`;

      toast.info(toastMessage, {
        position: "top-right",
        autoClose: 10000,
        onClick: () => {
          actions.openChatModal(orderId);
        },
        onClose: () => {
          actions.removeToastShown(orderId);
        },
        style: {
          cursor: "pointer",
          whiteSpace: "pre-line",
        },
      });

      // console.log("handleOrderChat: Toast shown successfully", { orderId, orderNumber });
    } catch (error) {
      console.error("handleOrderChat: Error processing order chat", { orderId, error });

      actions.removeToastShown(orderId);

      toast.error(`${t("orderChat.newMessageFromDriver")} (${orderId})`, {
        position: "top-right",
        autoClose: 5000,
        onClick: () => {
          actions.openChatModal(orderId);
        },
        style: {
          cursor: "pointer",
        },
      });
    }
  };
};

export const createPartnerChatHandler = (state, actions, user, t) => {
  return async (data) => {
    if (!data) {
      console.warn("handlePartnerChat: No data provided");
      return;
    }

    const { expeditorCompanyId, clientCompanyId, from } = data;

    if (!expeditorCompanyId || !clientCompanyId) {
      console.warn("handlePartnerChat: Invalid message data", { expeditorCompanyId, clientCompanyId, from });
      return;
    }

    const isRecipient =
      (from === "expeditor" && user?.companyId === clientCompanyId) ||
      (from === "client" && user?.companyId === expeditorCompanyId);

    if (!isRecipient) {
      // console.log("handlePartnerChat: Message not for this user", {
      //   userCompanyId: user?.companyId,
      //   from,
      //   expeditorCompanyId,
      //   clientCompanyId,
      // });
      return;
    }

    const chatKey = `partner-${expeditorCompanyId}-${clientCompanyId}`;

    const openChat = state.openChats.get(chatKey);
    if (openChat?.refreshCallback) {
      // console.log("handlePartnerChat: Chat is already open, refreshing messages", { chatKey });
      try {
        await openChat.refreshCallback();
        return;
      } catch (error) {
        console.error("handlePartnerChat: Error refreshing open chat", { chatKey, error });
      }
    }

    if (state.toastsShown.has(chatKey)) {
      // console.log("handlePartnerChat: Toast already shown for this chat", { chatKey });
      return;
    }

    try {
      actions.addToastShown(chatKey);

      const partnerId = user?.companyId === expeditorCompanyId ? clientCompanyId : expeditorCompanyId;

      toast.info(t("orderChat.newMessagePartner"), {
        position: "top-right",
        autoClose: 10000,
        onClick: () => {
          actions.openChatModal(chatKey, "partner", partnerId);
        },
        onClose: () => {
          actions.removeToastShown(chatKey);
        },
        style: {
          cursor: "pointer",
        },
      });

      // console.log("handlePartnerChat: Toast shown successfully", { chatKey, partnerId });
    } catch (error) {
      console.error("handlePartnerChat: Error processing partner chat", { chatKey, error });
      actions.removeToastShown(chatKey);
    }
  };
};

export const createOrderMessageChatHandler = (state, actions, user, t, lang = "ru") => {
  return async (data) => {
    if (!data) {
      console.warn("handleOrderMessageChat: No data provided");
      return;
    }

    const { orderId, receiverId, receiverCompanyId, from, isAirOrder, isSystem } = data;

    if (!orderId) {
      console.warn("handleOrderMessageChat: Invalid message data", { orderId, from });
      return;
    }

    const isRecipient =
      (receiverId && user?.id === receiverId) || (receiverCompanyId && user?.companyId === receiverCompanyId);

    if (!isRecipient) {
      // console.log("handleOrderMessageChat: Message not for this user", {
      //   userId: user?.id,
      //   userCompanyId: user?.companyId,
      //   receiverId,
      //   receiverCompanyId,
      // });
      return;
    }

    const openChat = state.openChats.get(orderId);
    if (openChat?.refreshCallback) {
      // console.log("handleOrderMessageChat: Chat is already open, refreshing messages", { orderId });
      try {
        await openChat.refreshCallback();
        return;
      } catch (error) {
        console.error("handleOrderMessageChat: Error refreshing open chat", { orderId, error });
      }
    }

    if (isSystem === true) {
      return;
    }

    if (state.toastsShown.has(orderId)) {
      // console.log("handleOrderMessageChat: Toast already shown for this order", { orderId });
      return;
    }

    try {
      actions.addToastShown(orderId);

      const orderResponse = isAirOrder 
        ? await Aviation.getAirOrdersById(orderId, lang)
        : await Order.getOrderById(orderId, lang);

      if (!orderResponse?.data) {
        throw new Error("No order data received");
      }

      const orderData = orderResponse.data;
      const cityFromName = orderData.cityFromName || "Не указан";
      const cityToName = orderData.cityToName || "Не указан";
      const orderNumber = orderData.number || "Без номера";

      const toastMessage = `${t("orderChat.newMessage")}
${t("orderChat.order")}: №${orderNumber}
${cityFromName} - ${cityToName}`;

      toast.info(toastMessage, {
        position: "top-right",
        autoClose: 10000,
        onClick: () => {
          actions.openChatModal(orderId, "order", null, isAirOrder);
        },
        onClose: () => {
          actions.removeToastShown(orderId);
        },
        style: {
          cursor: "pointer",
          whiteSpace: "pre-line",
        },
      });

      // console.log("handleOrderMessageChat: Toast shown successfully", { orderId, orderNumber });
    } catch (error) {
      console.error("handleOrderMessageChat: Error processing order message chat", { orderId, error });

      actions.removeToastShown(orderId);

      toast.error(`${t("orderChat.newMessage")} (${orderId})`, {
        position: "top-right",
        autoClose: 5000,
        onClick: () => {
          actions.openChatModal(orderId, "order", null, isAirOrder);
        },
        style: {
          cursor: "pointer",
        },
      });
    }
  };
};
